var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dataForm.id ? "编辑兑换券区间" : "添加兑换券区间",
            visible: _vm.dialogVisible,
            "before-close": _vm.handleClose,
            closeOnClickModal: false,
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingFrom,
                      expression: "loadingFrom",
                    },
                  ],
                  ref: "dataForm",
                  attrs: {
                    model: _vm.dataForm,
                    "label-width": "75px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区间名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "16",
                          placeholder: "请输入区间名称",
                        },
                        model: {
                          value: _vm.dataForm.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dataForm,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dataForm.name",
                        },
                      }),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v("区间名称用于用户端的兑换券筛选标签展示"),
                      ]),
                    ],
                    1
                  ),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "app-container home flex" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区间范围：", prop: "minNum" } },
                          [
                            _c("el-input-number", {
                              attrs: {
                                min: 0,
                                max: 999998,
                                step: 1,
                                "step-strictly": "",
                              },
                              model: {
                                value: _vm.dataForm.minNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.dataForm,
                                    "minNum",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "dataForm.minNum",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "symbol" }, [_vm._v("一")]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "maxNum", "label-width": "0" } },
                          [
                            _c("el-input-number", {
                              attrs: {
                                min: 1,
                                max: 999999,
                                step: 1,
                                "step-strictly": "",
                              },
                              model: {
                                value: _vm.dataForm.maxNum,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.dataForm,
                                    "maxNum",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "dataForm.maxNum",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "from-tips symbol-tips" }, [
                      _vm._v(
                        "用户端点击对应的区间名称会根据此兑换券范围筛选展示"
                      ),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序：", prop: "sort" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          max: 99,
                          step: 1,
                          "step-strictly": "",
                        },
                        model: {
                          value: _vm.dataForm.sort,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dataForm,
                              "sort",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dataForm.sort",
                        },
                      }),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v("请输入0~99的数字，数字越大越靠前"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "区间状态：" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "显示",
                          "inactive-text": "隐藏",
                          "active-value": true,
                          "inactive-value": false,
                        },
                        model: {
                          value: _vm.dataForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "status", $$v)
                          },
                          expression: "dataForm.status",
                        },
                      }),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v("关闭之后，此区间在用户端不展示"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleClose("dataForm")
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "platform:integral:interval:save",
                        "platform:integral:interval:update",
                      ],
                      expression:
                        "['platform:integral:interval:save', 'platform:integral:interval:update']",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.onsubmit("dataForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }